import { render, staticRenderFns } from "./Pisos.vue?vue&type=template&id=004dea56"
import script from "./Pisos.vue?vue&type=script&lang=js"
export * from "./Pisos.vue?vue&type=script&lang=js"
import style0 from "./Pisos.vue?vue&type=style&index=0&id=004dea56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports